import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getHot } from "@/lib/media";
import TitleGrid from "@/components/base/TitleGrid";

export default function NotFound() {
  const location = useLocation();
  const hot = getHot(6);

  usePageMeta({
    title: "页面未找到 - 西瓜影音",
    description: "抱歉，你访问的页面不存在。返回西瓜影音首页，继续浏览高清电影、电视剧与影视资讯。",
    keywords: "404,页面未找到,西瓜影音",
  });

  return (
    <div className="w-full animate-fade-in">
      <section className="relative w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
        <div className="relative">
          <span className="font-heading text-[7rem] md:text-[12rem] font-bold leading-none text-background-800 select-none">
            404
          </span>
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 md:w-24 md:h-24 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-emotion-sad-line text-4xl md:text-5xl text-background-50"></i>
          </span>
        </div>
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mt-6 mb-4">
          页面未找到
        </h1>
        <p className="text-sm md:text-base text-foreground-400 max-w-xl leading-relaxed mb-2">
          你访问的页面不存在或已被移除，可能是链接输入有误。
        </p>
        <p className="text-xs text-foreground-500 font-mono mb-8 break-all max-w-xl">{location.pathname}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 px-6 py-3 rounded-md bg-background-800 hover:bg-background-700 text-foreground-100 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-search-line"></i>
            去搜索影视
          </Link>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-16 md:pb-20">
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-50 mb-5 flex items-center gap-2.5">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          或许你会喜欢
        </h2>
        <TitleGrid items={hot} />
      </section>
    </div>
  );
}